import PaginationPager from '../components/PaginationPager.vue';

export default {
    components: {
        PaginationPager,
    },
    data() {
        return {
            pagination: {
                current: 1,
                total: 1,
            },
        };
    },
    watchQuery: ['page'],
};
